import React, { Component } from "react";
import styles from "./App.less";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Punish from "./pages/punish/$id";
import Appeal from "./pages/appeal/$id";
import Appealentrance from "./pages/appealentrance";
import Appealspentrance from "./pages/appealspentrance";
import AppealList from "./pages/appealList";
import PenaltyList from "./pages/penaltyList";
import Error from "./pages/500";
import Error404 from "./pages/404";
import { getQueryString } from "./utils/utils";

const baseUrl = "/case/home";
class App extends Component {
  
  render() {
    const templateId = getQueryString('templateId')
    return (
      <div className={templateId==='2'?styles.container:styles.containerBox} id="container">
        <Router>
          <Switch>
            <Route
              exact={true}
              path={`${baseUrl}/list`}
              component={AppealList}
            />
            <Route
              exact={true}
              path={`${baseUrl}/punish/list`}
              component={PenaltyList}
            />
            <Route
              exact={true}
              path={`${baseUrl}/punish/detail/:id`}
              component={Punish}
            />
            <Route
              exact={true}
              path={`${baseUrl}/detail/:id`}
              component={Appeal}
            />
            <Route
              exact={true}
              path={`${baseUrl}/appealentrance`}
              component={Appealentrance}
            />
            <Route
              exact={true}
              path={`${baseUrl}/appealspentrance`}
              component={Appealspentrance}
            />
            <Route
              exact={true}
              path={`${baseUrl}/error`}
              component={Error}
            />
            <Route
              exact={true}
              path={`${baseUrl}/404`}
              component={Error404}
            />
            <Route exact={true} path={baseUrl} component={PenaltyList} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
